import { FormattedMessage } from 'react-intl'

import SupportPopularArticles from '@/components/features/support/SupportPopularArticles'
import SupportSearchBar from '@/components/features/support/SupportSearchBar'
import SupportTopic from '@/components/features/support/SupportTopic'
import SupportSkeleton from '@/components/skeletons/SupportSkeleton'

const SupportPortalTab = () => {
  const isLoading = false

  return (
    <div className="space-y-7 tablet:space-y-10">
      <SupportSearchBar />
      {isLoading && (
        <SupportSkeleton className="mt-5 tablet:mt-8 desktop:mt-5" />
      )}
      <div className="space-y-5 tablet:space-y-8">
        {false && (
          <div>
            <h4 className="mb-4 text-xl font-medium leading-xl tablet:mb-5 tablet:text-2xl desktop:leading-3xl">
              <FormattedMessage
                {...{
                  id: 'support.topics',
                  defaultMessage: 'Темы'
                }}
              />
            </h4>
            <SupportTopic />
          </div>
        )}
        <div>
          <h4 className="mb-4 text-xl font-medium leading-xl tablet:mb-5 tablet:text-2xl desktop:leading-3xl">
            <FormattedMessage
              {...{
                id: 'support.popularArticles',
                defaultMessage: 'Популярные статьи'
              }}
            />
          </h4>
          <SupportPopularArticles />
        </div>
      </div>
    </div>
  )
}

export default SupportPortalTab
